import React, { PureComponent } from 'react'
import * as R from 'ramda'
import i18n from 'i18next'
import { Link } from 'react-router-dom'
import Button from '@UniformComponents/Button'

import DataTable from '../../DataTable'
import SearchInput from '../../Search'
import { observer } from 'mobx-react'

@observer
class Search extends PureComponent {
    tableColumns = [
        {
            name: 'id',
            key: 'id',
        },
        {
            name: 'Kpi',
            key: 'kpiId',
        },
        {
            name: 'Name',
            key: 'name',
        },
        {
            name: 'Industry',
            key: 'industry',
        },
        {
            name: 'Product Type',
            key: 'productType',
        },
        {
            name: 'Survey Type',
            key: 'surveyType',
        },
        {
            name: 'Respondent Type',
            key: 'respondentType',
        },
        {
            name: '',
            key: 'id',
            dataTransform: (id) => (
                <Link style={{ fontSize: '22px' }} className="fal fa-edit" to={`/intranet/kpicreator/${id}`} onClick={(e) => e.stopPropagation()} />),
        },
        {
            name: '',
            key: 'id',
            dataTransform: (id) => (
                <i style={{ fontSize: '22px' }} className="fal fa-trash-alt" onClick={(e) => this.deleteKpi(e, id)} />),
        },
    ]

    constructor(props) {
        super(props)

        this.state = {
            ready: false,
        }
    }

    async componentDidMount() {
        const { kpiStore } = this.props

        await kpiStore.search()
        this.setState({
            ready: true,
        })
    }

    deleteKpi = async (e, id) => {
        e.preventDefault()
        e.stopPropagation()

        const { kpiStore } = this.props
        await kpiStore.delete(id)
    }

    renderDataTable = () => {
        const { history, kpiStore } = this.props
        const { filteredKpis } = kpiStore

        const tableArgs = {
            data: filteredKpis,
            columns: this.tableColumns,
            rowClick: (e, id) => { history.push(`/intranet/kpicreator/${id}`) },
            rowId: 'id',
            emptyMessage: 'There are no kpis',
        }

        if (tableArgs.data.length > 0) {
            return (
                <DataTable
                    store={{ filteredList: tableArgs.data }}
                    dataSet={tableArgs.data}
                    columns={tableArgs.columns}
                    rowClick={tableArgs.rowClick}
                    rowId={tableArgs.rowId}
                    inMemory
                    numRows={tableArgs.data.length}
                />
            )
        }
        return <div>{tableArgs.emptyMessage}</div>
    }

    goToNew = () => {
        const { history } = this.props
        history.push('/intranet/kpicreator/0')
    }

    render() {
        const { kpiStore } = this.props
        const { ready } = this.state

        return (
            <div id="mergeFieldSearch" className="mergeFieldSearch">
                <div>
                    {ready
                    && (
                        <div className="panel">
                            <Button type="button" onClick={this.goToNew} cssClass="regular primary">Create New Kpi</Button>
                            <SearchInput
                                ref={(s) => { kpiStore.searchModule = s }}
                                onSearch={kpiStore.filter}
                            />
                            {this.renderDataTable()}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default Search
